import { AfterViewInit, Component, ElementRef, Input, NgZone, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';
import { ScrollEvent } from 'devextreme/ui/scroll_view';
import { IErrorItemInterface } from '../../interfaces/ErrorBox/IErrorBoxItems';

@Component({
    selector: 'app-error-box',
    templateUrl: 'error-box.component.html',
    styleUrls: ['error-box.component.scss'],
    standalone: false
})
export class ErrorBoxComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() isVisible: boolean = false;
  @Input() title: string;
  @Input() hint: string = '';
  @Input() items: IErrorItemInterface[];
  @Input() scrollView: DxScrollViewComponent;

  @ViewChild('messagesScrollView') messagesScrollView: DxScrollViewComponent;
  @ViewChild('messagesScrollView', { read: ElementRef }) messagesScrollElement: ElementRef<HTMLElement>;
  @ViewChild('messagesContent') messagesContent: ElementRef<HTMLElement>;

  hasMoreAbove: boolean = false;
  hasMoreBelow: boolean = false;
  private resizeObserver: ResizeObserver;
  // private scrollAnimationFrame: number | undefined;

  constructor(private ngZone: NgZone) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isVisible && !this.isVisible) {
      // this.stopScrollAnimation();
      this.hasMoreAbove = false;
      this.hasMoreBelow = false;
    }
  }

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(() => {
      if (this.isVisible) {
        this.ngZone.run(() => {
          void this.messagesScrollView.instance.update();
        });
      }
    });
    this.resizeObserver.observe(this.messagesScrollElement.nativeElement);
    this.resizeObserver.observe(this.messagesContent.nativeElement);
  }

  updateScrollIndicator(event: ScrollEvent): void {
    const isScrollableVisible = this.isVisible && event.component.clientHeight() > 0;
    // DevExtreme berücksichtigt die tatsächlichen Scrollgrenzen und deren Rundung.
    this.hasMoreAbove = isScrollableVisible && event.reachedTop === false;
    this.hasMoreBelow = isScrollableVisible && event.reachedBottom === false;
  }

  scrollHintsUp(): void {
    const scrollView = this.messagesScrollView?.instance;
    if (!this.isVisible || !scrollView) {
      return;
    }    
    // this.scrollHints(-1);
    const pageHeight = scrollView.clientHeight();
    const remainingHeight = scrollView.scrollTop();
    if (pageHeight > 0 && remainingHeight > 0) {
      scrollView.scrollBy({ top: -Math.min(pageHeight, remainingHeight) });    
    }
  }

  scrollHintsDown(): void {
    // this.scrollHints(1);
  // }

  // stopScrollAnimation(): void {
  //   if (this.scrollAnimationFrame !== undefined) {
  //     cancelAnimationFrame(this.scrollAnimationFrame);
  //     this.scrollAnimationFrame = undefined;
  //   }
  // }

  // private scrollHints(direction: number): void {
  //   this.stopScrollAnimation();
    const scrollView = this.messagesScrollView?.instance;
    // const pageHeight = scrollView?.clientHeight() ?? 0;
    if (!this.isVisible || !scrollView) {
      return;
    }

    const pageHeight = scrollView.clientHeight();
    if (pageHeight > 0) {
      scrollView.scrollBy({ top: pageHeight });    
    // const startTop = scrollView.scrollTop();
    // const targetTop = Math.max(0, startTop + direction * pageHeight);
    // if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    //   scrollView.scrollTo({ top: targetTop });
    //   return;
    }

    // const startTime = performance.now();
    // const duration = 280;
    // const animate = (timestamp: number): void => {
    //   this.scrollAnimationFrame = undefined;
    //   const progress = Math.min((timestamp - startTime) / duration, 1);
    //   const easedProgress = progress * progress * (3 - 2 * progress);
    //   scrollView.scrollTo({ top: startTop + (targetTop - startTop) * easedProgress });
    //   if (progress < 1) {
    //     this.scrollAnimationFrame = requestAnimationFrame(animate);
    //   }
    // };
    // this.ngZone.runOutsideAngular(() => {
    //   this.scrollAnimationFrame = requestAnimationFrame(animate);
    // });
  }

  ngOnDestroy(): void {
    // this.stopScrollAnimation();
    this.resizeObserver?.disconnect();
  }
}
